module.exports = __webpack_public_path__ + "img/1 (6).ab7417cf.png";